// WWM-18181: a single source of truth for the Text custom field limit, so the
// input's maxLength, the character counter, and the Dromo import validator
// cannot drift apart.
export const CUSTOM_FIELD_TEXT_MAX_LENGTH = 300

// WWM-18181: how many lines a read-only custom field value may wrap to on a
// detail page before it clamps and defers to the hover tooltip.
export const CUSTOM_FIELD_VALUE_CLAMP_LINES = 3
